import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { AreaOfWork } from '@models/areaOfWork.model';

@Component({
  selector: 'app-expansion-panel-group',
  templateUrl: './expansion-panel-group.component.html',
  styleUrls: ['./expansion-panel-group.component.scss'],
})
export class ExpansionPanelGroupComponent {

  @Input() projectDetails: AreaOfWork[] = [];

  @Output() loadProject: EventEmitter<any> = new EventEmitter<any>();
  
  isWorkSelected = false;

  @ViewChildren('expansionPanel') expansionItems!: QueryList<ElementRef>;

  togglePanel(data: any) {
    this.expansionItems.map((item : any) => {
      if (item !== data) {
        item.isOpened = false;
      }
    })
    data.isOpened = !data.isOpened;
  }
}
